import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';

const defaultFilter = { status: 'any' };

const loadScheduleMonthly = (filter) => {
  const query = qs.stringify(_.defaults(filter, defaultFilter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/monthly-schedules${query}`);
  }
  return axiosAPI.get('/monthly-schedules?status=any');
};

const loadScheduleById = (scheduleId) => {
  return axiosAPI.get(`/monthly-schedules/${scheduleId}`);
};

const addSchedule = (body) => {
  return axiosAPI.post('/monthly-schedules', body);
};

const updateScheduleById = (scheduleId, newSchedule) => {
  return axiosAPI.put(`/monthly-schedules/${scheduleId}`, newSchedule);
};

const deleteMonthlySchedule = (scheduleId) => {
  return axiosAPI.delete(`monthly-schedules/${scheduleId}`, scheduleId);
};

export {
  loadScheduleMonthly,
  loadScheduleById,
  addSchedule,
  updateScheduleById,
  deleteMonthlySchedule,
};
